import { getClient, withScope } from '../currentScopes.js';
import { captureMessage, captureException } from '../exports.js';
import { defineIntegration } from '../integration.js';
import { addConsoleInstrumentationHandler } from '../utils-hoist/instrument/console.js';
import { CONSOLE_LEVELS } from '../utils-hoist/logger.js';
import { addExceptionMechanism } from '../utils-hoist/misc.js';
import { severityLevelFromString } from '../utils-hoist/severity.js';
import { safeJoin } from '../utils-hoist/string.js';
import { GLOBAL_OBJ } from '../utils-hoist/worldwide.js';
var INTEGRATION_NAME = 'CaptureConsole';
var _captureConsoleIntegration = function _captureConsoleIntegration() {
  var _options$handled;
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var levels = options.levels || CONSOLE_LEVELS;
  var handled = (_options$handled = options.handled) !== null && _options$handled !== void 0 ? _options$handled : true;
  return {
    name: INTEGRATION_NAME,
    setup: function setup(client) {
      if (!('console' in GLOBAL_OBJ)) {
        return;
      }
      addConsoleInstrumentationHandler(function (_ref) {
        var args = _ref.args,
          level = _ref.level;
        if (getClient() !== client || !levels.includes(level)) {
          return;
        }
        consoleHandler(args, level, handled);
      });
    }
  };
};

/**
 * Send Console API calls as Sentry Events.
 */
var captureConsoleIntegration = defineIntegration(_captureConsoleIntegration);
function consoleHandler(args, level, handled) {
  var captureContext = {
    level: severityLevelFromString(level),
    extra: {
      arguments: args
    }
  };
  withScope(function (scope) {
    scope.addEventProcessor(function (event) {
      event.logger = 'console';
      addExceptionMechanism(event, {
        handled: handled,
        type: 'console'
      });
      return event;
    });
    if (level === 'assert') {
      if (!args[0]) {
        var _message = "Assertion failed: ".concat(safeJoin(args.slice(1), ' ') || 'console.assert');
        scope.setExtra('arguments', args.slice(1));
        captureMessage(_message, captureContext);
      }
      return;
    }
    var error = args.find(function (arg) {
      return arg instanceof Error;
    });
    if (error) {
      captureException(error, captureContext);
      return;
    }
    var message = safeJoin(args, ' ');
    captureMessage(message, captureContext);
  });
}
export { captureConsoleIntegration };